import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _modalVariants;

import { AddNewOrganizationModal, AddNewRegistrarModal } from '@modals';
import { Modals } from '@enums';
export var modalVariants = (_modalVariants = {}, _defineProperty(_modalVariants, Modals.AddNewRegistrar, AddNewRegistrarModal), _defineProperty(_modalVariants, Modals.AddNewOrganization, AddNewOrganizationModal), _modalVariants);